export default "__VITE_ASSET__44f54704__"